module.exports = __webpack_public_path__ + "img/icon_join_jieri@2x.f64f8bab.png";